import * as React from "react";
import MultiTag from "../multiTag";
// import MultiSelect from "widget/multiSelect2";
import { connect } from "react-redux";

interface IOrderTag {
  // 数据源
  orderTag: any;
  onChange: any;
  getOrderTag: any;
  placehorder?: any;
  value?: any;
  onRef?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

// 订单标签 多选标签
class OrderTag extends React.Component<IOrderTag, any> {
  state = {
    multiTagCurrent: null
  };

  constructor(props: IOrderTag) {
    super(props);

    this.props.onRef && this.props.onRef(this);
  }

  componentDidMount() {
    this.props.getOrderTag();
  }

  shouldComponentUpdate(nextProps) {
    // 当value值由值变化为空时，清空组件的状态恢复到初始化状态
    if (
      this.props.value &&
      this.props.value.length > 0 &&
      (!nextProps.value || nextProps.value.length == 0)
    ) {
      this.clear();
    }
    return true;
  }

  // 获取多选标签的引用
  getRef = multiTagCurrent => {
    this.setState({
      multiTagCurrent
    });
  };

  // 清除选中的标签
  clear = () => {
    const multiTagCurrent: any = this.state.multiTagCurrent;
    if (multiTagCurrent) {
      multiTagCurrent.clear();
    }
  };

  render() {
    return (
      <MultiTag
        data={this.props.orderTag}
        value={this.props.value}
        optionSize={5}
        returnCheckedOption={this.props.onChange}
        placehorder={this.props.placehorder}
        onRef={this.getRef}
        containerBody={this.props.containerBody}
      />
    );
    // return <MultiSelect />;
  }
}

const mapState = state => ({
  orderTag: state.share.orderTag
});

const mapDispatch = dispatch => {
  return {
    getOrderTag: dispatch.orderTag.getOrderTag
  };
};

export default connect(
  mapState,
  mapDispatch
)(OrderTag);
